import * as form from '../form';

export const legalInvestigationsForeign = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        ForeignGovernment: form.country(xitem.ForeignGovernment),
        Granted: form.branch(xitem.Granted)
      },
    };
  });
  return {
    HasForeignInvestigations: form.branch(data?.HasForeignInvestigations),
    List: form.collection(items, (data.List || {}).branch),
  };
};
